import React from 'react';
import { ImageCodeigniter, ImageLaravel, ImageNodeJS, ImagePython, ImageReact, ImageWordPress } from '../../../assets/images';

function TechnologyHome(props) {
  return (
    <div id="TechnologyHome">
      <div className="technology-home-description">
        <h1>Which technology we use</h1>
        <p>We use some technology that is quite widely used</p>
      </div>
      <div className="technology-home-group">
        <TechnologyLogo image={ImageReact} />
        <TechnologyLogo image={ImageNodeJS} />
        <TechnologyLogo image={ImageLaravel} />
        <TechnologyLogo image={ImageCodeigniter} />
        <TechnologyLogo image={ImagePython} />
        <TechnologyLogo image={ImageWordPress} />
      </div>
    </div>
  );
}

const TechnologyLogo = ({ image }) => {
  return (
    <div className="technology-logo">
      <img src={image} alt="logo-tech" />
    </div>
  )
}

export default TechnologyHome;